import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import { Link as RouterLink } from "react-router-dom";
import { toaster } from "../utils/toast";
import { services } from "../services";
import link2Outline from "@iconify/icons-eva/link-2-outline";
// import { Icon } from '@iconify/react';
// material
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField,
} from "@mui/material";
// components
import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import SearchNotFound from "../components/SearchNotFound";
import {
  UserListHead,
  UserListToolbar,
  UserMoreMenu,
} from "../components/_dashboard/user";
//
import USERLIST from "../_mocks_/user";
import {
  capitalizeFirstLetter,
  compactAddress,
  getContractInstance,
} from "src/contractData/function";
import getContractAddresses from "src/contractData/addresses";
import { web3 } from "src/web3";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { LoadingButton } from "@mui/lab";
import { enableMetamask, getWeb3 } from "src/helper/metamask";
import axios from "../config";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "srNo", label: "Sr No", alignRight: false },
  { id: "action", label: "Admin Action", alignRight: false },
  { id: "time", label: "Created At", alignRight: false },
  { id: "creator", label: "Created By", alignRight: false },
  { id: "email", label: "Email", alignRight: false },
  { id: "message", label: "Message", alignRight: false },
  //   { id: 'duration', label: 'Duration', alignRight: false },
  //   { id: 'staked', label: 'Staked Balance', alignRight: false },
  //   { id: 'total', label: 'Total reward Balance', alignRight: false },
  //   { id: 'reward', label: 'Reward Balance', alignRight: false },

  // { id: "tokenAddress", label: "Token Address", alignRight: false },
  // { id: "loyalityPoints", label: "Loyality Points", alignRight: false },
  { id: "" },
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "30px",
  boxShadow: 24,
  p: 4,
};

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function CheckLogs() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  // const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [addFundsModal, setAddFundsModal] = useState(false);
  const [selectedPool, setSelectedPool] = useState(-1);
  const [poolData, setPoolData] = useState([]);
  const [amount, setAmount] = useState("");
  // Remove these imports
  // import { web3 } from "src/web3";
  // import { enableMetamask, getWeb3 } from "src/helper/metamask";
  // import { compactAddress, getContractInstance } from "src/contractData/function";
  // import link2Outline from "@iconify/icons-eva/link-2-outline";
  
  // Remove these states
  const [web3Data, setWeb3Data] = useState();
  const [allowance, setAllowance] = useState();
  const [userBalance, setUserBalance] = useState();
  const [totalSupply, setTotalSupply] = useState();
  
  // Remove these functions
  // callUserData, checkAllowance, addFunds, approve
  
  // Update the header section
  <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
    <Typography variant="h4" gutterBottom>
      Check logs History
    </Typography>
  </Stack>
  
  // Remove the Modal component at the bottom
  const [logData, setLogData] = useState([]);

  const callUserData = async () => {
    let _web3Data = await getWeb3();
    if (_web3Data.isLoggedIn) {
      setWeb3Data(_web3Data);
    } else {
      _web3Data = await enableMetamask();
      console.log(_web3Data);
      setWeb3Data(_web3Data);
    }
  };
  const checkAllowance = async () => {
    if (!web3Data.isLoggedIn)
      return toaster(`${"Please connect to metamask"}`, "error");
    console.log("1");
    const tokenContractInstance = getContractInstance(
      poolData[selectedPool].contractType == "staking"
        ? "RaiserToken"
        : "lpToken",
      poolData[selectedPool].tokenAddress
    );
    console.log("1");

    setAllowance(
      Number(
        await tokenContractInstance.methods
          .allowance(
            web3Data.accounts[0],
            poolData[selectedPool].contractAddress
          )
          .call()
      )
    );
    console.log("1");

    setUserBalance(
      web3.utils.fromWei(
        await tokenContractInstance.methods
          .balanceOf(web3Data.accounts[0])
          .call(),
        "ether"
      )
    );
    console.log(await tokenContractInstance.methods.totalSupply().call());
    setTotalSupply(await tokenContractInstance.methods.totalSupply().call());
  };

  // Add pagination state
  const [totalRecords, setTotalRecords] = useState(0);
  
  // Update getPools function
  const getPools = async () => {
    try {
      const url = `/logs/list?page=${page + 1}&limit=${rowsPerPage}`;
      const sendRequest = await services.Get(url);
      if (sendRequest.status === 200) {
        setLogData(sendRequest.data.data);
        setTotalRecords(sendRequest.data.pagination.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching logs:", error);
      setLogData([]);
    }
  };
  
  // Update useEffect to depend on page and rowsPerPage
  useEffect(() => {
    getPools();
    callUserData();
  }, [page, rowsPerPage]);
  
  // Update TablePagination component
  // Remove this standalone TablePagination component
  // <TablePagination
  //   rowsPerPageOptions={[10, 20, 30]}
  //   component="div"
  //   count={totalRecords}
  //   rowsPerPage={rowsPerPage}
  //   page={page}
  //   onPageChange={handleChangePage}
  //   onRowsPerPageChange={handleChangeRowsPerPage}
  // />
  
  // Keep only the useEffect
  useEffect(() => {
    getPools();
    callUserData();
  }, [page, rowsPerPage]);
  
  useEffect(() => {
    if (selectedPool >= 0) checkAllowance();
  }, [selectedPool]);
  async function getContractData(pools) {
    let _poolData = [];
    const stakePools = [7, 14, 30, 60, "farmingContract"];
    const allPoolDetails = await Promise.all(
      pools.map(async (pool) => {
        const obj = {};

        // const address = getContractAddresses[];
        const ContractInstance = getContractInstance(
          pool.contractType,
          pool.contractAddress
        );
        obj.poolName = pool.poolName;
        obj.tokenAddress = pool.tokenAddress;
        obj.loyalityPoints = pool.loyalityPoints;
        obj.contractAddress = pool.contractAddress;
        obj.stakedBalance = +web3.utils.fromWei(
          await ContractInstance.methods.stakedBalance().call()
        );
        obj.totalReward = +web3.utils.fromWei(
          await ContractInstance.methods.totalReward().call()
        );
        obj.rewardBalance = +web3.utils.fromWei(
          await ContractInstance.methods.rewardBalance().call()
        );
        obj.contractId = pool.id;
        obj.name = capitalizeFirstLetter(pool.contractType);
        obj.poolName = capitalizeFirstLetter(pool.poolName);
        obj.duration =
          obj.name == "Farming"
            ? "-"
            : +(await ContractInstance.methods.lockDuration().call()) / 24;

        _poolData.push(obj);
      })
    );
    setPoolData(_poolData);
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(
    USERLIST,
    getComparator(order, orderBy),
    filterName
  );

  const isUserNotFound = filteredUsers.length === 0;
  const addFunds = async () => {
    const ContractInstance = getContractInstance(
      poolData[selectedPool].name,
      poolData[selectedPool].contractAddress
    );
    if (!web3Data.isLoggedIn)
      return toaster(`${"Please connect to metamask"}`, "error");
    await ContractInstance.methods
      .addReward(web3.utils.toWei(amount))
      .send({ from: web3Data.accounts[0] })
      .on("transactionHash", (hash) => {
        return toaster(`${"Transaction submitted"}`, "warn");
      })
      .on("receipt", (receipt) => {
        return toaster(`${"Transaction Successful"}`, "success");
      })
      .on("error", (error) => {
        return toaster(`${"Transaction Reverted"}`, "error");
      });
  };
  const approve = async () => {
    const tokenContractInstance = getContractInstance(
      poolData[selectedPool].contractType == "staking"
        ? "RaiserToken"
        : "lpToken",
      poolData[selectedPool].tokenAddress
    );
    if (!web3Data.isLoggedIn) {
      return toaster(`${"Please connect to metamask"}`, "error");
    }
    console.log(poolData[selectedPool].contractAddress, totalSupply);
    await tokenContractInstance.methods
      .approve(poolData[selectedPool].contractAddress, totalSupply)
      .send({ from: web3Data.accounts[0] })
      .on("transactionHash", (hash) => {
        return toaster(`${"Transaction submitted"}`, "warn");
      })
      .on("receipt", (receipt) => {
        return toaster(`${"Transaction Successful"}`, "success");
      })
      .on("error", (error) => {
        return toaster(`${"Transaction Reverted"}`, "error");
      });
  };

  const deletePool = async (id) => {
    const url = `/pools/delete/${id}`;
    const headers = {
      "Content-Type": "application/json",
      "x-auth-token": localStorage.getItem("token"),
    };

    const sendRequest = await axios.delete(url, { headers: headers });

    if (sendRequest.status === 200) {
      getPools();

      return toaster(`${"Pool is deleted successfully"}`, "success");
    }
  };
  return (
    <Page title="Pools | Raiser Snapshot">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Check logs History
          </Typography>
          
        </Stack>

        <Card style={{backgroundColor: '#151517'}}>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={USERLIST.length}
                  onRequestSort={handleRequestSort}
                  pooltab={true}
                />
                <TableBody>
                  {logData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((log, id) => {
                      return (
                        <TableRow hover key={id} tabIndex={-1}>
                          <TableCell spacing={2}>{id + 1}</TableCell>
                          <TableCell component="th" scope="row" padding="none">
                            {log.action}
                          </TableCell>
                          <TableCell align="left">{log.createdAt}</TableCell>
                          <TableCell align="left">
                            {log.createdBy.username}
                          </TableCell>
                          <TableCell align="left">
                            {log.createdBy.email}
                          </TableCell>
                          <TableCell align="left">{log.message}</TableCell>
                          {/* <TableCell align="right">
                            <UserMoreMenu
                              menu="pools"
                              setSelectedPool={setSelectedPool}
                              setAddFundsModal={setAddFundsModal}
                              id={id}
                              //   contractId={pool.contractId}
                              deletePool={deletePool}
                            />
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      <Modal
        open={addFundsModal}
        onClose={() => setAddFundsModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <h3 style={{ textAlign: "center", marginBottom: "30px" }}>
              {+allowance ? "Add Reward" : "Approve"}
            </h3>
          </Typography>
          {+allowance ? (
            <TextField
              fullWidth
              autoComplete="contract"
              type="text"
              label="Amount"
              onChange={(e) => setAmount(e.target.value)}
              // {...getFieldProps("contract")}
            />
          ) : null}
          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            // loading={isSubmitting}
            style={{ marginTop: "25px" }}
            onClick={() => (+allowance ? addFunds() : approve())}
          >
            {+allowance ? "Add" : "Approve"}
          </LoadingButton>
        </Box>
      </Modal>
    </Page>
  );
}
